module.exports = __webpack_public_path__ + "img/okay-meter.540f4644.svg";